import * as Category from 'marketplace-ui-common/constants/groupTags/Category';
import createObjectValuesPropType from './createObjectValuesPropType';
export default createObjectValuesPropType(Category);